import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

/** The two rights of the tab «Уведомление»: a message when the decoration of an order changes, and a message about a new order. */
export type NotificationKey = 'decor_modified_notification' | 'create_order_notification';

export interface NotificationGrantTitle {
  ru: string;
  kk?: string;
  en?: string;
}

/** The state of one key for one employee on one store: the grant of this very store (`grantId`) and, when it is given higher in the tree, the group it comes from. */
export interface NotificationGrantItem {
  key: NotificationKey;
  active: boolean;
  grantId: number | null;
  inheritedFrom: { id: number; title: NotificationGrantTitle; kind: 'G' | 'D' | 'S' } | null;
}

/**
 * The narrow endpoint of the tab «Уведомление»: `GET/PUT /api/vn/users/{userId}/notification-grants` on the store the page is opened for. The common CRUD of the rights
 * is for the admin only; this one is for the manager of the store and touches only the two notification keys of one store.
 */
@Injectable({ providedIn: 'root' })
export class UserNotificationService {
  constructor(private http: HttpClient) {
  }

  getGrants(userId: number, storeId: number): Promise<{ items: NotificationGrantItem[] }> {
    const params = new HttpParams().set('store_id', String(storeId));
    return firstValueFrom(this.http.get<{ items: NotificationGrantItem[] }>(`/api/vn/users/${userId}/notification-grants`, { params }));
  }

  setGrant(userId: number, key: NotificationKey, storeId: number, active: boolean): Promise<{ grantId: number | null }> {
    return firstValueFrom(this.http.put<{ grantId: number | null }>(`/api/vn/users/${userId}/notification-grants/${key}`, { storeId, active }));
  }
}
